export default __webpack_public_path__ + "static/media/61.81440c8b.png";